/* eslint-disable react/jsx-no-comment-textnodes */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { images } from "../../constants";

import { AppWrap } from "../../wrapper";
import MotionWrap from "../../wrapper/MotionWrap";

import "./Skills.scss";
// import "react-tooltip/dist/react-tooltip.css";

type Skill = {
  name: string;
  bgColor: string;
  icon: string;
};

type Work = {
  name?: string;
  desc?: string;
  imgUrl?: string;
  projectLink?: string;
  codeLink?: string;
  title?: string;
  tags?: string[];
  company?: string;
};

type Experience = {
  year: string;
  works?: Work[];
}[];

const skillsData = [
  { id: 1, imageUrl: images.amazon, name: "AWS" },
  { id: 2, imageUrl: images.css, name: "CSS" },
  { id: 3, imageUrl: images.docker, name: "Docker" },
  { id: 4, imageUrl: images.figma, name: "Figma" },
  { id: 5, imageUrl: images.git, name: "GIT" },
  { id: 6, imageUrl: images.graphql, name: "GraphQL" },
  { id: 7, imageUrl: images.html, name: "HTML" },
  { id: 8, imageUrl: images.javascript, name: "JavaScript" },
  { id: 9, imageUrl: images.node, name: "NodeJS" },
  { id: 10, imageUrl: images.react, name: "React" },
  { id: 11, imageUrl: images.redux, name: "Redux" },
  { id: 12, imageUrl: images.sass, name: "Sass" },
  { id: 14, imageUrl: images.typescript, name: "TypeScript" },
  { id: 15, imageUrl: images.terraform, name: "Terraform" },
  { id: 16, imageUrl: images.golang, name: "Golang" },
  { id: 17, imageUrl: images.nestjs, name: "Nest JS" },
  { id: 18, imageUrl: images.nextjs, name: "Next JS" },
  { id: 19, imageUrl: images.kubernetes, name: "Kubernetes" },
  { id: 18, imageUrl: images.reactnative, name: "React Native" },
  { id: 19, imageUrl: images.stripe, name: "Stripe" },
  { id: 20, imageUrl: images.android, name: "Android" },
  { id: 21, imageUrl: images.ios, name: "iOS" },
  { id: 22, imageUrl: images.java, name: "Java" },
  { id: 23, imageUrl: images.swift, name: "Swift" },
  { id: 24, imageUrl: images.postgresql, name: "PostgreSQL" },
  { id: 25, imageUrl: images.serverlessFramework, name: "Serverless" },
  { id: 26, imageUrl: images.python, name: "Python" },
].sort((a, b) => a.name.localeCompare(b.name));

const newWorks: Experience = [
  {
    year: "2024",
    works: [
      {
        company: "Babbel",
        imgUrl: images.babbel,
        desc: "Integrating Stripe for subscription payments.",
        name: "Senior Full Stack Engineer",
      },
    ],
  },
  {
    year: "2024",
    works: [
      {
        company: "One Planet Crowd",
        imgUrl: images.opc,
        desc: "Building out a payments, onboarding and KYC platform.",
        name: "Principle Full Stack Engineer",
      },
    ],
  },
  {
    year: "2023",
    works: [
      {
        company: "Codam Coding College",
        imgUrl: images.codam,
        desc: "Delivering professional development workshops.",
        name: "Engineering Mentor",
      },
    ],
  },
  {
    year: "2023",
    works: [
      {
        company: "Global School For Entrepreneurship",
        imgUrl: images.gs4e,
        desc: "Mentoring entrepreneurs today for the tech world of tomorrow.",
        name: "Business Technology Coach",
      },
    ],
  },
  {
    year: "2022",
    works: [
      {
        company: "Nationale Nederlanden",
        imgUrl: images.nn,
        desc: "Building a neo banking app.",
        name: "Senior Full Stack Engineer",
      },
    ],
  },
  {
    year: "2021",
    works: [
      {
        company: "Codam Coding College",
        imgUrl: images.codam,
        desc: "Mentoring tech students.",
        name: "Software Mentor",
      },
    ],
  },
  {
    year: "2020",
    works: [
      {
        company: "INFO Business Innovation Partner",
        imgUrl: images.info,
        desc: "Technology consultancy and delivery.",
        name: "Lead Software Engineer",
      },
    ],
  },
  {
    year: "2019",
    works: [
      {
        company: "Backbase",
        imgUrl: images.backbase,
        desc: "Design & delivery of omni-channel banking platforms.",
        name: "Senior Technical Solutions Engineer",
      },
    ],
  },
];

const Skills = () => {
  // const [skills, setSkills] = useState<Skill[]>([]);
  const [experience, setExperience] = useState<Experience>([
    {
      year: "",
      works: [
        {
          codeLink: "",
          desc: "",
          imgUrl: "",
          name: "",
          projectLink: "",
          tags: [],
          title: "",
        },
      ],
    },
  ]);

  // useEffect(() => {
  //   const experiencesQuery = '*[_type == "experiences"]';
  //   // const skillsQuery = '*[_type == "skills"]';
  //   //@ts-ignore

  //   client.fetch(experiencesQuery).then((data) => {
  //     setExperience(data);
  //   });

  //   //@ts-ignore
  //   // client.fetch(skillsQuery).then((data) => {
  //   //   setSkills(data);
  //   // });
  //   console.log(experience);
  // }, []);

  return (
    <>
      <h2 className="head-text">
        Current <span>Technology</span> Stack
      </h2>
      <div className="app__skills-container">
        <motion.div className="app__skills-list">
          {skillsData?.map((skill) => (
            <motion.div
              whileInView={{ opacity: [0, 1] }}
              transition={{ duration: 0.5 }}
              className="app__skills-item app__flex"
              key={skill.name}
            >
              <div
                className="app__flex"
                style={{ backgroundColor: "rgb(237, 242, 248)" }}
              >
                <img src={skill.imageUrl} alt={skill.name} />
              </div>
              <p className="p-text">{skill.name}</p>
            </motion.div>
          ))}
        </motion.div>

        {/* <motion.div className="app__skills-exp">
          {newWorks?.map((exp) => (
            <motion.div className="app__skills-exp-item" key={exp.year}>
              <div className="app__skills-exp-year">
                <p className="bold-text">{exp.year}</p>
              </div>
              <motion.div className="app__skills-exp-works">
                {exp.works?.map((work) => (
                  <>
                    <motion.div
                      whileInView={{ opacity: [0, 1] }}
                      transition={{ duration: 0.5 }}
                      className="app__skills-exp-work"
                      // data-tip
                      // data-for={work.name}
                      data-tooltip-id={work.name}
                      data-tooltip-content={work.desc}
                      data-tooltip-place="top"
                      key={work.name}
                    >
                      <div style={{ display: "flex" }}>
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <h4 className="bold-text">{work.name}</h4>
                          <p className="p-text">{work.company}</p>
                        </div>
                        <div>
                          <img
                            style={{ width: "80px", height: "50px" }}
                            src={work.imgUrl}
                            alt={work.name}
                          />
                        </div>
                      </div>
                    </motion.div>
                    <Tooltip
                      id={work.name}
                      arrowColor="#fff"
                      // openOnClick={true}
                      // className="skills-tooltip"
                    >
                      {work.desc}
                    </Tooltip>
                  </>
                ))}
              </motion.div>
            </motion.div>
          ))}
        </motion.div> */}
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Skills, "app__skills"),
  "skills",
  "app__whitebg",
);
